import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Phone from "@mui/icons-material/Phone";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import PersonOutline from "@mui/icons-material/PersonOutline";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, enAU } from "date-fns/locale";
import { format } from "date-fns";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TimeLoader } from "../_components/loaders/TimeLoader";
import TextMaskPhone from "../_components/TextMaskPhone";
import { BigButton } from "./Components/Buttons";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import { Link as RouterLink } from "react-router-dom";
import { SanitizeEmail } from "./utils/EmailUtils";
// Removing temporarily
// import { importScript } from "../_helpers/importScript";
import { LifeSafer } from "../_helpers/BrandConstants";
import {
  // Removing temporarily
  // validateReCaptcha,
  verifyEnrollee,
  verifyText,
  verifyEmail,
} from "../_api/usersApi";
import { UserVerify } from "../_api/registerApi";
import { updateClientEmail } from "../_api/profileApi";
import Cookies from "universal-cookie";

const iconStyling = { opacity: 0.6, color: "#1c355e", paddingRight: "5px" };
const PersonalInformation = ({ handleNext, UpdateUserInfo }) => {
  const cookies = new Cookies();
  // Removing temporarily
  // importScript(
  //   `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`
  // );
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const locale = countryCode === "USA" ? enUS : enAU;
  const { t } = useTranslation();
  const brandIdentifier = LifeSafer;
  const [disableInputs, setDisableInputs] = useState(false);
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [existingEmail, setExistingEmail] = useState("");
  const [sanitizedExistingEmail, setSanitizedExistingEmail] = useState("");

  const [openPhoneDialog, setOpenPhoneDialog] = useState(false);
  const closePhoneDialog = () => {
    setOpenPhoneDialog(false);
  };

  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const closeEmailDialog = () => {
    setOpenEmailDialog(false);
  };

  const [openVerificationDialog, setOpenVerificationDialog] = useState(false);
  const openVerification = () => {
    setOpenPhoneDialog(false); // close previous dialog before opening next.
    setOpenVerificationDialog(true);
  };
  const closeVerificationDialog = () => {
    setOpenVerificationDialog(false);
  };

  const [verificationCodeIncorrect, setVerificationCodeIncorrect] =
    useState(false);
  const [verificationCodeExpired, setVerificationCodeExpired] = useState(false);
  const validateVerificationCode = () => {
    let verificationInfo = {
      userId: userInfo.userID,
      resetCode: getValues("verificationCode"),
      brandIdentifier: brandIdentifier,
    };
    verifyEnrollee(verificationInfo)
      .then((verifyResponse) => {
        if (verifyResponse.message === "Invalid") {
          setValue("verificationCode", "");
          setVerificationCodeIncorrect(true);
        }
        if (verifyResponse.message === "Expired") {
          setValue("verificationCode", "");
          setVerificationCodeExpired(true);
        }
        if (verifyResponse.message === undefined) {
          // set verification info for jwt
          cookies.set("lifesaferUser", JSON.stringify(verifyResponse), {
            path: "/",
            sameSite: "strict",
          });
          updateClientEmail(userInfo)
            .then((response) => {
              console.info("Update Email Response", { response });
              history.push({ pathname: "/" });
            })
            .catch((error) => {
              console.error(t("registration.emailUpdateError"), error);
              toast.error(t("registration.emailUpdateError"));
              cookies.remove("lifesaferUser"); // remove cookie so failure to update does not 'log in' user.
            });
          closeVerificationDialog();
        }
      })
      .catch((error) => {
        console.error(error);
        showApiErrorToast();
      });
  };
  const showApiErrorToast = () => {
    toast.error(
      <div>
        <Typography variant="h6" style={{ textDecoration: "underline" }}>
          {t("registration.apiErrorTitle")}
        </Typography>
        <Typography variant="body2">{t("registration.apiError")}</Typography>
      </div>
    );
  };

  const showContactUsToast = () => {
    toast.warn(
      <div>
        <Typography variant="h6" style={{ textDecoration: "underline" }}>
          {t("registration.contactUs")}
        </Typography>
        <Typography variant="body2">
          {t("registration.contactUsMessage")}
        </Typography>
      </div>,
      { autoClose: false }
    );
  };
  let phoneTypeList = [
    { label: t("registration.cellPhone"), abbrev: "Cell" },
    { label: t("registration.homePhone"), abbrev: "Home" },
  ];
  const { register, errors, control, handleSubmit, getValues, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      defaultValues: {
        phoneTypeInfo: phoneTypeList[0],
        phoneType: "cell",
      },
    });
  const submitPersonalInfo = (data) => {
    data.dob = format(new Date(data.dob), "yyyy/MM/dd").toString();
    setDisableInputs(true);
    setShowLoadingSpinner(true);
    let personalInformation = {
      BrandIdentifier: brandIdentifier,
      Email: data.email,
      FirstName: data.firstName,
      LastName: data.lastName,
      Phone: data.phoneNumber.replace(/\D/g, ""),
      UserId: 0,
      DOB: data.dob,
    };
    // 'Honey Pot' to try to catch 'bots'
    // false means the box is not checked.
    if (data.call_me_out !== false) {
      toast.error(t("registration.honeyPotError"));
    } else {
      // Removing temporarily
      // TODO : Remove ReCaptcha Permanently?
      // window.grecaptcha.enterprise.ready(() => {
      //   window.grecaptcha.enterprise
      //     .execute(process.env.REACT_APP_RECAPTCHA_KEY, {
      //       action: "login",
      //     })
      //     .then((token) => {
      //       validateReCaptcha(token)
      //         .then((result) => {
      //           if (result.message === "Authorized") {

      UserVerify(personalInformation).then((verificationResponse) => {
        setUserInfo({
          clientID: verificationResponse.clientID,
          userID: verificationResponse.userID,
          email: data.email, // new email entered by user
          firstName: data.firstName,
          lastName: data.lastName,
          homePhone: data.phoneNumber.replace(/\D/g, ""),
          cellPhone:
            data.phoneType === "cell"
              ? data.phoneNumber.replace(/\D/g, "")
              : "",
        });
        setExistingEmail(verificationResponse.phoneNameEmail);
        UpdateUserInfo({ brandIdentifier, ...data });
        if (
          verificationResponse.emailExists === false &&
          verificationResponse.phoneNameExists === false
        ) {
          handleNext();
        }
        if (verificationResponse.emailExists === true) {
          setOpenEmailDialog(true);
          setDisableInputs(false);
          setShowLoadingSpinner(false);
        }
        if (
          verificationResponse.phoneNameExists === true &&
          verificationResponse.emailExists === false
        ) {
          let sanitized = SanitizeEmail(verificationResponse.phoneNameEmail);
          setSanitizedExistingEmail(sanitized);
          setOpenPhoneDialog(true);
          setDisableInputs(false);
          setShowLoadingSpinner(false);
        }
      });
      // removing temporarily
      // TODO : Remove ReCaptcha Permanently?
      //   } else {
      //     console.log("ReCaptcha not authorized.");
      //   }
      // })
      // .catch((error) => {
      //   console.error("Error validating ReCaptcha : ", error);
      //   showApiErrorToast();
      //   setDisableInputs(false);
      //   setShowLoadingSpinner(false);
      // });
      // });
      // });
    }
  };
  return (
    <Grid container direction="column">
      <form onSubmit={handleSubmit(submitPersonalInfo)}>
        <TextField
          name="email"
          label={t("registration.emailAddress")}
          size="small"
          margin="normal"
          required
          autoFocus
          fullWidth
          disabled={disableInputs}
          error={!!errors.email}
          helperText={errors.email ? errors.email.message : ""}
          InputProps={{
            startAdornment: <EmailOutlined sx={iconStyling} />,
          }}
          inputRef={register({
            required: { value: true, message: t("registration.emailRequired") },
            pattern: {
              value: /^\S+@\S+$/i,
              message: t("registration.emailValid"),
            },
          })}
          data-cy="register-email"
        />
        <TextField
          name="firstName"
          label={t("registration.firstName")}
          size="small"
          margin="normal"
          required
          fullWidth
          disabled={disableInputs}
          InputProps={{
            startAdornment: <PersonOutline sx={iconStyling} />,
          }}
          error={!!errors.firstName}
          helperText={errors.firstName ? errors.firstName.message : ""}
          inputRef={register({
            required: {
              value: true,
              message: t("registration.firstNameRequired"),
            },
            validate: (value) => {
              if (value.length >= 2) {
                return true;
              } else {
                return t("registration.firstNameLengthError");
              }
            },
          })}
          data-cy="register-first-name"
        />
        <TextField
          name="lastName"
          label={t("registration.lastName")}
          size="small"
          margin="normal"
          required
          fullWidth
          disabled={disableInputs}
          InputProps={{
            startAdornment: <PersonOutline sx={iconStyling} />,
          }}
          error={!!errors.lastName}
          helperText={errors.lastName ? errors.lastName.message : ""}
          inputRef={register({
            required: {
              value: true,
              message: t("registration.lastNameRequired"),
            },
            validate: (value) => {
              if (value.length >= 2) {
                return true;
              } else {
                return t("registration.lastNameLengthError");
              }
            },
          })}
          data-cy="register-last-name"
        />
        <TextField
          select
          name="phoneType"
          label={t("registration.phoneType")}
          size="small"
          margin="normal"
          required
          fullWidth
          disabled={disableInputs}
          defaultValue={"cell"}
          inputRef={register({
            required: true,
            name: "phoneType",
          })}
          onChange={(event) => setValue("phoneType", event.target.value)}
        >
          <MenuItem value={"cell"}>{t("registration.cellPhone")}</MenuItem>
          <MenuItem value={"home"}>{t("registration.homePhone")}</MenuItem>
        </TextField>

        <Controller
          control={control}
          name="phoneNumber"
          defaultValue={null}
          rules={{
            required: {
              value: true,
              message: t("registration.phoneNumberRequired"),
            },
            validate: (value) => {
              if (value.replace(/\D/g, "").length === 10) {
                return true;
              } else {
                return t("registration.phoneValid");
              }
            },
          }}
          render={(props) => (
            <TextField
              {...props}
              label={t("registration.phoneNumber")}
              required
              fullWidth
              size="small"
              margin="dense"
              disabled={disableInputs}
              error={!!errors.phoneNumber}
              helperText={errors.phoneNumber ? errors.phoneNumber.message : ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                inputComponent: TextMaskPhone,
                startAdornment: <Phone sx={iconStyling} />,
              }}
              data-cy="register-phone-number"
            />
          )}
          data-cy="register-phone-number"
        />
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={locale}
        >
          <Controller
            control={control}
            name="dob"
            defaultValue={null}
            rules={{
              required: {
                value: true,
                message: t("registration.dateOfBirthRequired"),
              },
              validate: (value) => {
                let minDate = moment().subtract(100, "years");
                let maxDate = moment().subtract(14, "years");
                if (value.toString() === "Invalid Date")
                  return t("registration.dateOfBirthInvalid");
                if (value < minDate || value > maxDate) {
                  return t("registration.dateOfBirthInvalid");
                }
                return true;
              },
            }}
            render={(props) => (
              <DesktopDatePicker
                {...props}
                id="dob"
                label={t("registration.dateOfBirth")}
                inputFormat={countryCode === "AU" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                disableFuture
                openTo="year"
                views={["year", "month", "day"]}
                disabled={disableInputs}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    required
                    margin="normal"
                    size="small"
                    error={!!errors.dob}
                    helperText={errors.dob ? errors.dob.message : ""}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            )}
          />
        </LocalizationProvider>
        <Grid container justifyContent="center" sx={{ paddingTop: "2em" }}>
          {showLoadingSpinner ? (
            <Grid item>
              <TimeLoader />
            </Grid>
          ) : (
            <Grid item>
              <BigButton variant="contained" color="primary" type="submit">
                {t("registration.verifyPersonalInformation")}
              </BigButton>
            </Grid>
          )}
        </Grid>
        <input
          type="checkbox"
          id="call_me_out"
          name="call_me_out"
          style={{ display: "none" }}
          tabIndex="-1"
          autoComplete="off"
          ref={register({})}
        />
      </form>
      {/* Phone Dialog */}
      <Dialog
        open={openPhoneDialog}
        onClose={closePhoneDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {t("registration.phoneNumberInUse")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span style={{ display: "inline-block", paddingBottom: 15 }}>
              {t("registration.continueToLogin")}
              {`${sanitizedExistingEmail} `}
              <strong>
                <RouterLink
                  onClick={() => {
                    toast.dismiss();
                  }}
                  to="account/login"
                >
                  {t("registration.returnToLogin")}
                </RouterLink>
              </strong>
            </span>
            <span style={{ display: "inline-block" }}>
              {t("registration.verifyEmail")}
              <strong
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  toast.dismiss();
                  let verifyTextInfo = {
                    EmailAddress: existingEmail,
                    BrandIdentifier: brandIdentifier,
                    Silent: false,
                  };
                  if (countryCode === "USA") {
                    verifyText(verifyTextInfo) // usa
                      .then((response) => {
                        if (response.message === "Sent") openVerification();
                        else {
                          showApiErrorToast();
                          setDisableInputs(false);
                        }
                      })
                      .catch((error) => {
                        console.error(error);
                        if (
                          error.message.includes(
                            "User profile is missing Cell Phone Number."
                          )
                        )
                          showContactUsToast();
                        else showApiErrorToast();
                        setDisableInputs(false);
                      });
                  } else if (countryCode === "AU") {
                    verifyEmail(verifyTextInfo)
                      .then((response) => {
                        // what is the success response?
                        if (response.message === "Sent") {
                          openVerification();
                        } else {
                          showApiErrorToast();
                          setDisableInputs(false);
                        }
                      })
                      .catch((error) => {
                        console.error(error);
                        // any special case error messages?
                        showApiErrorToast();
                        setDisableInputs(false);
                      });
                  }
                }}
              >
                {t("registration.here")}
              </strong>
            </span>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* Email Dialog */}
      <Dialog
        open={openEmailDialog}
        onClose={closeEmailDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {t("registration.emailInUse")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("registration.emailInUseInstructions")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenEmailDialog(false);
            }}
            sx={{ marginRight: ".5em" }}
          >
            {t("registration.changeEmail")}
          </Button>
          <RouterLink
            style={{ textDecoration: "none", color: "white" }}
            to={`account/forgot-password?email=${encodeURIComponent(
              getValues("email")
            )}`}
          >
            <Button variant="contained" color="primary">
              {t("registration.resetPassword")}
            </Button>
          </RouterLink>
        </DialogActions>
      </Dialog>
      {/* Verification Dialog */}
      <form>
        <Dialog
          open={openVerificationDialog}
          onClose={closeVerificationDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {t("registration.verificationCodeTitle")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("registration.verificationCodeDescription")}
            </DialogContentText>
            <TextField
              autoFocus
              variant="outlined"
              margin="dense"
              id="verificationCode"
              name="verificationCode"
              label={t("registration.verificationCode")}
              type="text"
              fullWidth
              error={!!errors.verificationCode}
              helperText={
                errors.verificationCode ? errors.verificationCode.message : ""
              }
              inputRef={register({
                required: {
                  value: true,
                  message: t("registration.verificationCodeRequired"),
                },
                pattern: {
                  value: /^[0-9]{6,6}$/,
                  message: t("registration.verificationCodeInvalid"),
                },
              })}
            />
            {verificationCodeIncorrect && (
              <Typography style={{ color: "red", fontSize: "small" }}>
                {t("registration.verificationCodeIncorrect")}
              </Typography>
            )}
            {verificationCodeExpired && (
              <Typography style={{ color: "red", fontSize: "small" }}>
                {t("registration.verificationCodeExpired")}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={validateVerificationCode}
              color="primary"
              type="submit"
            >
              {t("registration.submitVerificationCode")}
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </Grid>
  );
};

PersonalInformation.propTypes = {
  handleNext: PropTypes.func,
  UpdateUserInfo: PropTypes.func,
};

export default PersonalInformation;
